import React from 'react';

import styles from './AuFormItemWrapper.module.scss';

interface IAuFormItemWrapper {
  className?: string;
  style?: React.CSSProperties;
}

const AuFormItemWrapper: React.FC<IAuFormItemWrapper> = ({ children, className = '' }) => (
  <div className={`${styles.itemWrapper} ${className}`}>
    {children}
  </div>
);

export default AuFormItemWrapper;